export default __webpack_public_path__ + "static/media/logo.83ad54f9.png";